/**
 * ProcessButton - View component for OCR processing button
 * Pure presentation component with no business logic
 */

import React from 'react';

export default function ProcessButton({ onClick, disabled, text }) {
  return (
    <button onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
}
